import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { style: {"font-size":"1.5rem"} }
const _hoisted_3 = { class: "mt-4 pl-4" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "d-flex justify-end" }
const _hoisted_6 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('schoolDiary.title')), 1),
      (_ctx.isFetching)
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            color: "primary",
            class: "mx-4",
            indeterminate: ""
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        large: "",
        color: "primary",
        variant: "flat",
        to: "/school-diary/create"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('schoolDiary.createNew')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-6 pa-2",
      color: "grey-lighten-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { align: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('schoolDiary.dateStart')), 1),
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.from,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.from) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('schoolDiary.dateEnd')), 1),
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.to,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.to) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t('schoolDiary.unapproved')), 1),
            _createVNode(_component_v_col, {
              cols: "1",
              class: "mt-10 ml-0 pl-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.check,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.check) = $event)),
                  disabled: _ctx.isFetching,
                  color: "primary"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "mt-4 search-button",
                  color: "primary",
                  variant: "flat",
                  large: "",
                  onClick: _ctx.searchBtn,
                  loading: _ctx.isFetching
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.search')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_table, null, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('common.date')), 1),
            _cache[5] || (_cache[5] = _createElementVNode("th", { class: "text-right" }, null, -1)),
            _cache[6] || (_cache[6] = _createElementVNode("th", {
              class: "text-left",
              style: {"width":"10%"}
            }, null, -1))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diaries, (d) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: d.date
            }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(d.date)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_5, [
                  (d.approvedBy.chief && d.approvedBy.chief != -1)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        color: "primary",
                        class: "mx-1",
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.chief')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (d.approvedBy.director && d.approvedBy.director != -1)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 1,
                        color: "primary",
                        class: "mx-1",
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.director')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (d.status === 'draft')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 2,
                        variant: "outlined",
                        class: "mx-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.draft')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (d.status === 'applied')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 3,
                        color: "primary",
                        variant: "outlined",
                        class: "mx-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.applied')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  to: `/school-diary/edit/${d.date}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.detail')), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_pagination, {
      class: "pt-4",
      modelValue: _ctx.page,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
      onInput: _ctx.pageClick,
      length: Math.ceil(_ctx.totalItemsCount / _ctx.limit)
    }, null, 8, ["modelValue", "onInput", "length"])
  ]))
}